import { BoMItemType } from 'model/Project/BoMItemRow'
import { AssemblyDetails } from './AssemblyDetails'
import { PartTypeDetails } from './PartTypeDetails'
import {
  BomItemDetailsProps,
  ProjectDetails,
} from './ProjectDetails/ProjectDetails'

export const BomItemDetail = (props: BomItemDetailsProps) => {
  switch (props.bomItemType) {
    case BoMItemType.project:
      return <ProjectDetails {...props} />
    case BoMItemType.assembly:
    case BoMItemType.assemblyHeader:
      return <AssemblyDetails {...props} />
    case BoMItemType.row:
      return <PartTypeDetails {...props} />
    default:
      return null
  }
}
